export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20curated%20luxury%20fashion%20essentials%20on%20white%20travertine%20stone%2C%20featuring%20polished%20leather%20loafers%20a%20silk%20scarf%20gold%20bracelet%20and%20slim%20watch%2C%20morning%20sunlight%20casting%20long%20soft%20shadows%2C%20editorial%20luxury%20magazine%20spread%20aesthetic%2C%20clean%20sophisticated%20composition%2C%20no%20text%20or%20logos&width=1800&height=900&seq=hero-v3-main&orientation=landscape"
        alt="Hoobuy Spreadsheet - Produtos de luxo selecionados"
        title="Hoobuy Spreadsheet Brasil - Melhores Links Verificados"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-4">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-heading text-white leading-tight">
          Melhor Hoobuy Spreadsheet
          <br />
          <span className="font-serif italic font-normal text-3xl md:text-5xl lg:text-6xl">
            em Português 2026
          </span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/85 max-w-[640px] mx-auto leading-relaxed">
          Links Atualizados Todos os Dias &bull; Mais de 5.000 Produtos para o Brasil
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-10 py-4 bg-white text-foreground-950 font-bold text-base rounded-full whitespace-nowrap cursor-pointer hover:bg-white/90 transition-all duration-300"
          >
            hoobuy sheet
          </a>
          <a
            href="#categories"
            className="px-10 py-4 border-2 border-white/60 text-white font-semibold text-base rounded-full whitespace-nowrap cursor-pointer hover:bg-white/15 transition-all duration-300"
          >
            Explorar Categorias
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#trust"
          className="text-white/60 hover:text-white transition-colors cursor-pointer"
          aria-label="Rolar para baixo"
        >
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-arrow-down-line text-2xl animate-bounce"></i>
          </div>
        </a>
      </div>
    </section>
  );
}